import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';

interface GalleryItem {
  product: string;
  image: string;
}


export default function Gallery() {
  const [userGallery, setUserGallery] = useState<GalleryItem[]>([]);
  const theme = useTheme();
  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/gallery.json`)
      .then(response => response.json())
      .then((data: GalleryItem[]) => setUserGallery(data))
      .catch(error => console.error('Error fetching gallery data:', error));
  }, []);

  return (
    <Box
      id="gallery"
      sx={{
        color: 'white',
        backgroundColor: theme.palette.mode === 'light' ? '#efefef' : '#06090a',
      }}
    >
      <Container
        sx={{
          pt: { xs: 4, sm: 12 },
          pb: { xs: 8, sm: 16 },
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4" color="text.primary">
            Galeria
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Zapoznaj się z najnowszymi zdjęciami od naszych klientów.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {userGallery.map((gallery, index) => (
            <Grid item xs={12} sm={6} md={6} key={index} sx={{ display: 'flex' }}>
              <Card
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  flexGrow: 1,
                  p: 1,
                }}
              >
                <CardHeader
                  title={
                    <Typography component="h6" variant="h6" color="text.primary" sx={{ textAlign: 'center' }}>
                      {gallery.product}
                    </Typography>
                  }
                />
                <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <img
                    src={gallery.image}
                    alt={`Logo ${index + 1}`}
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
